import { Button } from "@material-tailwind/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OptionInput from "../inputs/OptionInput";
import React from "react";
import StringInput from "../inputs/StringInput";
import { createCard } from "../../api/api";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useTopics } from "../hooks/useTopicsSimple";

function topicExists(topicName, topics) {
  return topics.some((topic) => topic.name === topicName);
}

const CardCreateModal = ({ token, onClose }) => {
  const [topic, setTopic] = useState("");
  const [cardType, setCardType] = useState(null);
  const { topics, loading, error } = useTopics(token);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (loading || error) {
    return <div>Loading...</div>;
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      <div className="bg-white rounded-xl shadow-lg w-11/12 md:w-3/4 lg:w-3/4 p-3 overflow-y-auto h-1/2">
        <div className="flex justify-between pb-4">
          <h2 className="text-xl font-bold">New Card</h2>
          <button onClick={onClose}>
            <FontAwesomeIcon
              icon={faXmark}
              className="text-gray-500 hover:text-black text-2xl"
            />
          </button>
        </div>

        <OptionInput
          label="Card Type"
          options={["display", "trigger", "action"]}
          value={cardType}
          onChange={setCardType}
        />

        {cardType === "display" && (
          <OptionInput
            label="Topic"
            value={topic}
            options="topics"
            onChange={setTopic}
          />
        )}

        {["action", "trigger"].includes(cardType) && (
          <StringInput label="Card Name" value={topic} onChange={setTopic} />
        )}

        <Button
          color="blue"
          ripple="light"
          disabled={cardType !== "display" && topicExists(topic, topics)}
          onClick={() => {
            createCard(token, topic, cardType).catch((error) => {
              console.error("Error creating card:", error);
            });
          }}
        >
          {cardType !== "display" && topicExists(topic, topics) ? (
            <>Name in use</>
          ) : (
            <>Create Card</>
          )}
        </Button>
      </div>
    </div>
  );
};

export default CardCreateModal;
